import createSpacingComponent from './Spacing'

const ComponentSpacing = createSpacingComponent('component')

export default ComponentSpacing
